module.exports = __webpack_public_path__ + "static/media/logo.6f726015.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.svg
// module id = 215
// module chunks = 0